<template>
  <div class="dropdowns">
    <q-card class="fit">
      <q-card-section class="columns">
        <PublisherDropdown v-model="data1.selectedPublishers" :options="data1.publishers" :loading="dropsLoading" />

        <YearDropdown v-model="data1.selectedYear" :options="data1.years" />
      </q-card-section>
    </q-card>

    <q-card class="fit">
      <q-card-section class="columns">
        <PublisherDropdown v-model="data2.selectedPublishers" :options="data2.publishers" :loading="dropsLoading" />

        <YearDropdown v-model="data2.selectedYear" :options="data2.years" />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn color="positive" :disable="!isApplyDisabled" @click="apply">
          Apply
        </q-btn>
      </q-card-actions>
    </q-card>
  </div>
</template>

<script>
import * as apiTo from '../../api'
import * as helpers from './helpers'
// Libraries
import { capitalize } from 'lodash'
// Components
import PublisherDropdown from './PublisherDropdown'
import YearDropdown from './YearDropdown'

export default {
  components: {
    PublisherDropdown,
    YearDropdown
  },

  data: () => ({
    data1: {
      publishers: null,
      years: helpers.getLast6Years(),
      selectedPublishers: [],
      selectedYear: null
    },
    data2: {
      publishers: null,
      years: helpers.getLast6Years(),
      selectedPublishers: [],
      selectedYear: null
    },
    dropsLoading: false
  }),

  computed: {
    isApplyDisabled() {
      return !!(this.areValuesSetFor('data1') && this.areValuesSetFor('data2'))
    }
  },

  created() {
    this.getPublishers()
  },

  methods: {
    areValuesSetFor(target) {
      return this[target].selectedPublishers.length && this[target].selectedYear
    },

    getPublishers() {
      this.dropsLoading = true
      apiTo
        .getAllPublishers()
        .then(({ data1, data2 }) => {
          this.data1.publishers = helpers.generatePublisherOptions(data1.result)
          this.data2.publishers = data2.result.map(p => ({
            label: capitalize(p),
            value: p
          }))
        })
        .finally(() => (this.dropsLoading = false))
    },

    apply() {
      this.$emit('filter-data', {
        subscription_publisher_ids: this.data1.selectedPublishers,
        subscription_year: this.data1.selectedYear,
        article_publisher_names: this.data2.selectedPublishers,
        article_year: this.data2.selectedYear
      })
    },

    getSubYear() {
      // acces from parent
      return this.data1.selectedYear
    },

    getArticleYear() {
      // acces from parent
      return this.data2.selectedYear
    }
  }
}
</script>

<style lang="stylus" scoped>
.dropdowns {
  display grid
  grid-template-columns repeat(auto-fit, minmax(200px, 1fr))
  gap 20px

  .columns {
    display grid
    grid-template-columns repeat(auto-fit, minmax(200px, 1fr))
    gap 10px
  }
}
</style>
